module.exports = __webpack_public_path__ + "static/media/bannerYT3.1a31ee0f.png";